export const findMediaByIdentifier = (medias, identifier) => {
  return medias.find((element) => {
    return element.identifier === identifier;
  });
};
